import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SignupPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const [referralCode, setReferralCode] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  // Grab referral code from #fragment if present
  useEffect(() => {
    const codeFromHash = window.location.hash?.slice(1);
    if (codeFromHash && !referralCode) {
      setReferralCode(codeFromHash);
    }
  }, [referralCode]);

  const handleSignup = async (e) => {
    e.preventDefault();
    setError('');

    if (password1 !== password2) {
      setError("Passwords don't match.");
      return;
    }

    if (username.length < 3) {
      setError('Username must be at least 3 characters.');
      return;
    }

    try {
      const res = await fetch('/api/auth/signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username,
          email,
          password: password1,
          referralCode,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || 'Signup failed.');
        return;
      }

      // Store token + user info and redirect
      localStorage.setItem('authToken', data.token);
      localStorage.setItem('authUser', JSON.stringify(data.user));
      navigate('/');
    } catch (err) {
      console.error('Signup error:', err);
      setError('Something went wrong. Try again.');
    }
  };

  return (
    <div className="p-8 max-w-md mx-auto">
      <h1 className="text-2xl font-bold mb-4">📝 Sign Up</h1>

      {error && <div className="text-red-600 mb-4">{error}</div>}

      <form onSubmit={handleSignup} className="space-y-4">
        <div>
          <label className="block font-semibold">Username</label>
          <input
            className="w-full border rounded p-2"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            autoFocus
          />
        </div>

        <div>
          <label className="block font-semibold">Email (optional)</label>
          <input
            className="w-full border rounded p-2"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div>
          <label className="block font-semibold">Password</label>
          <input
            className="w-full border rounded p-2"
            type="password"
            value={password1}
            onChange={(e) => setPassword1(e.target.value)}
            required
          />
        </div>

        <div>
          <label className="block font-semibold">Repeat Password</label>
          <input
            className="w-full border rounded p-2"
            type="password"
            value={password2}
            onChange={(e) => setPassword2(e.target.value)}
            required
          />
        </div>

        <div>
          <label className="block font-semibold">Referral Code</label>
          <input
            className="w-full border rounded p-2"
            value={referralCode}
            onChange={(e) => setReferralCode(e.target.value)}
          />
        </div>

        <button
          type="submit"
          className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
        >
          Sign Up
        </button>
      </form>
    </div>
  );
}
